import React from 'react'
import 'leaflet/dist/leaflet.css'
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'

/**
* @author zilahir
* @function Map
**/

const MakkaraMap = (props) => {
	const position = [60.169383, 24.936079]
	return (
		<div className="makkarapaiva-map">
			{
				typeof window !== 'undefined'
					? (
						<Map center={position} zoom={15}>
							<TileLayer
									url="https://api.mapbox.com/styles/v1/rzilahi/ck7bphnrb036c1ipd5e24bowx/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicnppbGFoaSIsImEiOiI2NzQ1MjA2NzMxZjU0Yjc5Y2M0OGExYTQxZmYzZjE1NSJ9.SGuh1di36V1TWMasX1PotA"
								/>
							<Marker
								position={position}
							>
								<Popup>
									Makkarapäivä
									Narinkka 4, FI-00100 Helsinki, Finland
								</Popup>
							</Marker>
  						</Map>
					)
					: null
			}
		</div>
	 )

 }

export default MakkaraMap